module.exports = __webpack_public_path__ + "2511bb0e79881c218c2f8a7b353176bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/quarantaene2.jpg
// module id = 907
// module chunks = 0